import React, {
  createContext,
  useCallback,
  useContext,
  useLayoutEffect,
  useMemo,
  useState,
} from "react";
import { getInitialHomeLoading, syncHomeLoadingClass } from "../helper/homeLoadingClass";

const PageLoadingContext = createContext({
  isPageLoading: false,
  setPageLoading: () => {},
});

export const PageLoadingProvider = ({ children }) => {
  const [isPageLoading, setIsPageLoading] = useState(() => getInitialHomeLoading());

  const setPageLoading = useCallback((loading) => {
    setIsPageLoading(loading);
    syncHomeLoadingClass(loading);
  }, []);

  useLayoutEffect(() => {
    syncHomeLoadingClass(isPageLoading);
  }, [isPageLoading]);

  const value = useMemo(
    () => ({ isPageLoading, setPageLoading }),
    [isPageLoading, setPageLoading]
  );

  return (
    <PageLoadingContext.Provider value={value}>
      {children}
    </PageLoadingContext.Provider>
  );
};

export const usePageLoading = () => useContext(PageLoadingContext);
